import { render } from "./ProviderReportCheckModal.vue?vue&type=template&id=493b287a&ts=true"
import script from "./ProviderReportCheckModal.vue?vue&type=script&lang=ts"
export * from "./ProviderReportCheckModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__